import React, { useState }                                        from 'react'
import axios                                                      from 'axios'
import { Button, Grid, TextField, TextareaAutosize, Typography }  from'@material-ui/core'
import { CLIENT_PUBLIC_TOKEN }                                    from '../../config'
import { node_server }                                            from '../../Helpers'
import PropTypes                                                  from 'prop-types'
import { store }                                                  from '../../Redux/Store'

const ClassNoteCreate = (props) => {

   const { noteCount, tpsClass } = props

   const { signedInUsername } = store.getState()

   const [ noteIndex,      setNoteIndex      ]  =  useState(0)
   const [ noteLink,       setNoteLink       ]  =  useState('')
   const [ noteTitle,      setNoteTitle      ]  =  useState('')
   const [ paragraph,      setParagraph      ]  =  useState([])
   const [ paragraphText,  setParagraphText  ]  =  useState('')

   const changeNoteIndex = (e) => {
      setNoteIndex(e.target.value)
   }

   const changeNoteTitle = (e) => {
      setNoteTitle(e.target.value)
   }

   const changeNoteLink = (e) => {
      setNoteLink(e.target.value)
   }

   const handleAddParagraph = () => {
      const tempParagraph = paragraph
      tempParagraph.push(paragraphText)
      setParagraph(tempParagraph)
      setParagraphText('')
   }

   const handleClassNoteTextChange = (e) => {
      setParagraphText(e.target.value)
   }

   const handleSubmit = () => {

   axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
   if (noteCount === 0) {
      axios.post(node_server + 'admin/classNote', {
         note: {
            note: paragraph,
            noteIndex: noteIndex,
            noteLink: noteLink,
            noteTitle: noteTitle,
         },
         signedInUsername,
         tpsClass: tpsClass,
      })
         .then( res => res.data )
         .then( data => {
            console.log('ClassNoteCreate data is', data)
         })
         .catch( (error) => {
            console.error(error)
         })
   }
   else {
      axios.put(node_server + 'admin/classNote', {
         note: {
            note: paragraph,
            noteIndex: noteIndex,
            noteLink: noteLink,
            noteTitle: noteTitle,
         },
         signedInUsername,
         tpsClass: tpsClass,
      })
         .then( res => res.data )
         .then( data => {
            console.log('ClassNoteCreate data is', data)
         })
         .catch( (error) => {
            console.error(error)
         })
      }
   }

   const paragraphsToDisplay = paragraph.map( (p,i) => {
      return (
         <Grid item xs={12} key={i} >
            <Typography style={{ textAlign: 'left', marginLeft: '5rem', marginBottom: '1rem' }}>{ p }</Typography>
         </Grid>
      )
   })

   return(
      <Grid>
         <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <TextField name='class-note-create-note-index-input' label="Note Index" onChange={changeNoteIndex} variant='outlined' style={{ width: '90%' }} value={noteIndex} />
         </Grid>
         <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <TextField name='class-note-create-note-title-input' label="Note Title" onChange={changeNoteTitle} variant='outlined' style={{ width: '90%' }} value={noteTitle} />
         </Grid>
         <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <TextField name='class-note-create-note-link-input' label="Note Link" onChange={changeNoteLink} variant='outlined' style={{ width: '90%' }} value={noteLink} />
         </Grid>
         {/* <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <TextareaAutosize data-testid='class-note-create-note-link-input' name='Note Paragraph' placeholder={'Note Paragraph'} minRows={5} style={{ width: '90%', fontSize: '1.5rem', padding: '0.5rem' }} onChange={changeNoteParagraph} value={noteParagraph} />
         </Grid> */}
         <Grid item xs={12}>
               <Typography style={{ marginTop: "1.5rem", marginLeft: "4rem", textAlign: "left" }}>
                  Paragraph(s)
               </Typography>
               <TextareaAutosize data-testid='class-note-create-paragraph-textarea' label="Class Note Paragraph" name="paragraph" minRows={5} style={{ width: "90%", fontSize: "1rem" }} onChange={handleClassNoteTextChange} value={paragraphText} />
               <Grid item xs={3} style={{ marginTop: "1.5rem" }}>
                  <Button data-testid='add-paragraph-button' variant="contained" color="primary" style={{ justifySelf: "left" }} onClick={handleAddParagraph}>Add Paragraph</Button>
               </Grid>
         </Grid>
         <Grid item xs={3} style={{ marginTop: "1.5rem" }}>
               <Button data-testid='new-class-note-submit-button' variant="contained" color="primary" style={{ justifySelf: "left" }} onClick={handleSubmit}>Submit</Button>
         </Grid>
         <Grid style={{ marginTop: '1.5rem' }} >
            { paragraphsToDisplay }
         </Grid>
      </Grid>
   )

}

ClassNoteCreate.propTypes = {
   noteCount: PropTypes.number,
   tpsClass: PropTypes.string
}

export default ClassNoteCreate